import { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import { motion, AnimatePresence } from "framer-motion"

const MSGS = [
  { h: "💬 Join the conversation", b: "Over 10,000 ideas shared daily on SQUIDS." },
  { h: "🔥 Your opinion matters", b: "Upvote posts, drop comments, be heard." },
  { h: "🌍 Built for Africa", b: "Questions, answers, and real communities." },
  { h: "✨ SQUIDS is free forever", b: "Sign up in seconds. No credit card needed." },
]

export function GuestPopup() {
  const [visible, setVisible] = useState(false)
  const [dismissed, setDismissed] = useState(false)
  const [msg] = useState(MSGS[Math.floor(Math.random() * MSGS.length)])
  const location = useLocation()

  useEffect(() => {
    if (dismissed) return
    const t = setTimeout(() => setVisible(true), 12000)
    return () => clearTimeout(t)
  }, [dismissed])

  const authPages = ["/auth/login", "/auth/register", "/auth/forgot-password"]
  if (authPages.some(p => location.pathname.startsWith(p))) return null

  const dismiss = () => { setVisible(false); setDismissed(true) }

  return (
    <AnimatePresence>
      {visible && !dismissed && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={dismiss}
            style={{
              position: "fixed", inset: 0, zIndex: 9998,
              background: "rgba(0,0,0,0.55)",
            }}
          />
          {/* Centered modal */}
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92, y: 20 }}
            transition={{ type: "spring", damping: 24, stiffness: 260 }}
            style={{
              position: "fixed",
              top: "50%", left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
              width: "min(90vw, 400px)",
              background: "var(--bg2)",
              border: "1px solid var(--border2)",
              borderRadius: "1.25rem",
              padding: "1.75rem",
              boxShadow: "0 24px 48px rgba(0,0,0,.5)",
            }}
          >
            {/* Close button */}
            <button
              onClick={dismiss}
              style={{
                position: "absolute", top: "1rem", right: "1rem",
                color: "var(--text3)", background: "none", border: "none",
                cursor: "pointer", padding: 4, borderRadius: 6,
              }}
              aria-label="Close"
            >
              <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div style={{ textAlign: "center" }}>
              {/* Logo */}
              <div style={{
                width: 56, height: 56, borderRadius: "1rem",
                background: "rgba(255,69,0,.12)",
                display: "flex", alignItems: "center", justifyContent: "center",
                margin: "0 auto 1rem",
              }}>
                <svg width="30" height="30" viewBox="0 0 48 48" fill="none">
                  <rect width="48" height="48" rx="8" fill="#ff4500" />
                  <path d="M15 17.5C15 14.462 17.462 12 20.5 12H29C30.105 12 31 12.895 31 14C31 15.105 30.105 16 29 16H20.5C19.672 16 19 16.672 19 17.5C19 18.328 19.672 19 20.5 19H27.5C30.538 19 33 21.462 33 24.5C33 27.538 30.538 30 27.5 30H19C17.895 30 17 30.895 17 32C17 33.105 17.895 34 19 34H28.5C29.328 34 30 34.672 30 35.5C30 36.328 29.328 37 28.5 37H19C16.239 37 14 34.761 14 32C14 29.239 16.239 27 19 27H27.5C28.328 27 29 26.328 29 25.5C29 24.672 28.328 24 27.5 24H20.5C17.462 24 15 21.538 15 18.5V17.5Z" fill="white" />
                </svg>
              </div>

              <h3 className="font-outfit font-bold" style={{ fontSize: "1.15rem", marginBottom: ".35rem" }}>{msg.h}</h3>
              <p style={{ fontSize: ".85rem", color: "var(--text2)", lineHeight: 1.6, marginBottom: "1.5rem" }}>{msg.b}</p>

              <div style={{ display: "flex", flexDirection: "column", gap: ".6rem" }}>
                <Link
                  to="/auth/register"
                  onClick={dismiss}
                  className="sq-btn sq-btn-primary"
                  style={{ justifyContent: "center", padding: ".65rem", width: "100%" }}
                >
                  Join SQUIDS — It's Free
                </Link>
                <Link
                  to="/auth/login"
                  onClick={dismiss}
                  className="sq-btn sq-btn-outline"
                  style={{ justifyContent: "center", padding: ".65rem", width: "100%" }}
                >
                  Log In
                </Link>
              </div>

              <p style={{ fontSize: ".7rem", color: "var(--text3)", marginTop: "1rem" }}>
                No credit card required.
              </p>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}
